(function () {
  function normalizeProductTitles() {
    const titles = document.querySelectorAll('.featured-product .product__title')
    titles.forEach((title) => {
      if (title.dataset.normalized) return
      title.textContent = title.textContent.toLowerCase()
      title.dataset.normalized = 'true'
    })
  }

  function initProductCardSizeSelectors() {
    const cards = document.querySelectorAll('[data-product-card][data-has-size-picker="true"]')
    if (!cards.length) return

    cards.forEach((card) => {
      const sizeList = card.querySelector('[data-product-card-size-list]')
      const variantInput = card.querySelector('[data-product-card-variant-input]')
      if (!sizeList || !variantInput) return

      const controls = Array.from(sizeList.querySelectorAll('input[data-variant-id]'))
      if (!controls.length) return

      const quickAddButtons = card.querySelectorAll('[data-product-card-submit]')

      const updateSelection = (input) => {
        if (!input || !input.dataset.variantId) return

        controls.forEach((control) => {
          const label = sizeList.querySelector(`label[for="${control.id}"]`)
          if (!label) return
          const isActive = control === input
          label.classList.toggle('is-active', isActive)
          label.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        })

        const variantId = input.dataset.variantId
        const available = input.dataset.available !== 'false'

        variantInput.value = variantId
        variantInput.setAttribute('value', variantId)
        variantInput.dispatchEvent(new Event('change', { bubbles: true }))

        card.setAttribute('data-default-variant-id', variantId)

        quickAddButtons.forEach((button) => {
          button.dataset.variantId = variantId

          if (!available) {
            button.setAttribute('disabled', '')
            button.setAttribute('aria-disabled', 'true')
          } else {
            button.removeAttribute('disabled')
            button.removeAttribute('aria-disabled')
          }

          const textElement = button.querySelector('[data-button-text]')
          if (!textElement) return

          const defaultText = textElement.getAttribute('data-default-text') || button.dataset.defaultText || textElement.textContent.trim()
          const soldOutText = textElement.getAttribute('data-sold-out') || defaultText
          const finalText = available ? defaultText : soldOutText

          textElement.textContent = finalText
          button.setAttribute('aria-label', finalText)
        })
      }

      controls.forEach((control) => {
        control.addEventListener('change', () => updateSelection(control))
      })

      const initialControl = controls.find((control) => control.checked) || controls.find((control) => !control.disabled)
      if (initialControl) {
        updateSelection(initialControl)
      }
    })
  }

  function onReady() {
    normalizeProductTitles()
    initProductCardSizeSelectors()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady)
  } else {
    onReady()
  }
})()
